import { styled } from 'stitches.config'

export const TrustpilotRoot = styled('div', {
  background: '$secondary-100',
  position: 'relative',
})

export const ReviewsWrapper = styled('div', {
  width: '100%',
  maxWidth: '1200px',
  position: 'relative',
  margin: 'auto',
  marginTop: '60px',
  marginBottom: '50px',
  '@bp3': {
    marginTop: '80px',
    marginBottom: '60px',
  },
})

export const FloatImage1 = styled('div', {
  position: 'absolute',
  top: '-40px',
  right: '20px',
  width: '60px',
  display: 'none',

  '@mobile': {
    display: 'block',
  },

  '@bp3': { top: '-50px', left: '800px', right: 0, margin: 'auto', width: '70px' },
})

export const FloatImage2 = styled('div', {
  position: 'absolute',
  width: '70px',
  display: 'none',
  bottom: '-40px',
  left: '20px',
  '@mobile': {
    display: 'block',
  },

  '@bp3': {
    margin: 'auto',
    left: 0,
    right: '900px',
    bottom: '-50px',
    width: '90px',
  },
})

export const TrustpilotContent = styled('div', {
  zIndex: 1,
  position: 'relative',
})